import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class TripStopGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripStopGrid = this;
		setTimeout(function(){
			tripStopGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripStopGrid = this;
	
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['TRIP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')						
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'transfer',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:filter', ' Add to GPS')						
					],
					listeners: {
						click: function() {
							actionTransferToGPS(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['TRIP_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['TRIP_MANAGEMENT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tripRefNo',
					header: 'Trip Ref No',
					width: '7em'
				},
				{						
					path: 'stopSeqNo',
					header: 'Stop Seq No',
					width: '7em'
				},
				{						
					path: 'arrivalDts',
					header: 'Arrival Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.arrivalDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'gpsArrivalDts',
					header: 'GPS Arrival Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.gpsArrivalDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stopTypeDescription',
					header: 'Stop Type',
					width: '7em'
				},
				{						
					path: 'location',
					header: 'Location',
					width: '7em',					
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.location.addressLine1 + ' ' + rowData.item.location.city + ', ' + rowData.item.location.stateProv + ' ' + rowData.item.location.country;					
					}
				},
				{						
					path: 'stopDistance',
					header: 'Stop Miles',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumStopDistance(rowData.item.stopDistance);
					}
				},				
				{						
					path: 'stopComment',
					header: 'Stop Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em',
					hidden: true
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				record.stopDistance.distances.forEach(function(d){
					var finalD = d.finalDistance;
					
					var distance = finalD.distance ? finalD.distance : 0;
					var toll = finalD.tollDistance ? finalD.tollDistance : 0;
					var ferry = finalD.ferryDistance ? record.ferryDistance : 0;

					if (record.distanceUom === 'KM') {
						totalDistance += UOMUtil.convertKMToMI(distance);
						totalToll += UOMUtil.convertKMToMI(toll);
						totalFerry += UOMUtil.convertKMToMI(ferry);
					} else {
						totalDistance += distance;
						totalToll += toll;
						totalFerry += ferry;
					}
				});
				
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;											
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'transfer').disabled = false;
						ElementUtil.query(toolbar, 'showMap').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;						
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'transfer').disabled = false;	
						ElementUtil.query(toolbar, 'showMap').disabled = false;						
					}
					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
					ElementUtil.query(toolbar, 'transfer').disabled = true;
					ElementUtil.query(toolbar, 'showMap').disabled = true;
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Planned Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'trip-stops',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var tractorId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').value;
					if (tractorId) {
						DataManagementService.getTripService().exportTripStops(tractorId, grid.currentFilter);					
					} else {
						window.DL.MessageUtil.showToastError('A tractor must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(tripStopGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(tripStopGrid.toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'arrivalDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							start:  startFilterDts,														
							end: endFilterDts,
							filterField: 'tripRefNo',
							filterValue: ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTripRefNo').value, 
							dateField: 'arrivalDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals;
							if (records.totatDistanceOfStops) {
								totals = {
									totalDistance: records.totatDistanceOfStops.distance,
									totalToll: records.totatDistanceOfStops.tollDistance,
									totalFerry: records.totatDistanceOfStops.ferryDistance
								};
							} else {
								totals = calcTotals(records.data);
							}
							distanceStatus.innerHTML = '<b>Planned Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						
						var tractorId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').value;
						if (tractorId) {						
							DataManagementService.getTripService().getTripStops(tractorId, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {
							loadMask.remove();
							if (tripStopGrid.nextLoadOfGrid) {
								ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').validate();								
								window.DL.MessageUtil.showToastError('A tractor must be selected');
							} else {
								tripStopGrid.nextLoadOfGrid = true;
							}
						}
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footerContainer
			]
		});		
		tripStopGrid.append(flexLayout);	

		tripStopGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionAddEdit = function(record) {
		
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Trip Stop' : 'Add Trip Stop',
				icon: 'vaadin:edit',				
				width: 700,
				height: 455,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits('TRACTOR', paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											itemid: 'tractorId',
											label: 'Tractor',
											name: 'tractorId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'tractorId');
														loadReferenceNo(ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-text-field',												
											name: 'tripRefNo',
											label: 'Trip Reference No',
											required: true,											
											maxLength: 80
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Arrival Date(mm/dd/yyyy hh:mm:ss)',
											name: 'arrivalDts',
											step: 1,
											required: true
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Departure Date(mm/dd/yyyy hh:mm:ss)',
											name: 'departureDts',
											step: 1
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},										
										{
											tag: 'vaadin-combo-box',											
											label: 'Stop Type',
											name: 'stopType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'PICKUP',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TripStopType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},										
										{
											tag: 'div',
											children: [
												{
													tag: 'dl-location-lookup',
													itemid: 'locationLookup',
													textstyle: 'width: calc(100% - 40px)',
													name: 'rawLocation',
													required: true									
												}
											]
										},											
										{
											tag: 'vaadin-text-field',										
											name: 'stopComment',
											label: 'Comment',											
											colspan: 2,
											maxLength: 255											
										},											
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;
															
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {																																		
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.stopId = record.stopId;
																	}																	
																	
																	return DataManagementService.getTripService().saveTripStop(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Trip Stop', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																	
																	addEditWin.close();
																	
																	var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
																	tripStopGrid.dispatchEvent(refreshEvent);
																	
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var updateTractorCB = function() {
							var tractorIdFilter = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').selectedItem;
							var initialValue = null;
							if (tractorIdFilter) {
								initialValue = tractorIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'tractorId');	
							loadReferenceNo(initialValue, refNoCB, function(cb) {
								if (tractorIdFilter) { 
									refNoCB.value = tractorIdFilter.code;
								}
							});
						};
						
						if (record) {								
							//wait for render;shift to end of event loop
							setTimeout(function() {
								
								var loadRecord = {
									tractorId: record.tractorId,
									tripRefNo: record.tripRefNo,
									arrivalDts: record.arrivalDts,
									departureDts: record.departureDts,
									rawLocation: record.location.latitude + ', ' + record.location.longitude,
									stopComment: record.stopComment,
									stopType: record.stopType									
								};
								var hasAddress = !!record.location.addressLine1;
								var hasLatLong = record.location.latitude && record.location.longitude;
								if (hasAddress) {
									var addressLocationParts = [record.location.addressLine1];
									if (record.location.city) {
										addressLocationParts.push(record.location.city);
									}
									if (record.location.stateProv) {
										addressLocationParts.push(record.location.stateProv);
									}
									loadRecord.rawLocation = addressLocationParts.join(', ');
								} else if (hasLatLong) {
									loadRecord.rawLocation = record.location.latitude + ', ' + record.location.longitude;
								} else if (record.location.stateProv) {
									loadRecord.rawLocation = record.location.stateProv + '-' + (record.location.country || '');
								}
								
								formPanel.load(loadRecord);																							
								updateTractorCB();
								var locationLookup = ElementUtil.query(formPanel, 'locationLookup');
								var locationTextField = locationLookup ? ElementUtil.query(locationLookup, 'text') : null;
								if (locationTextField) {
									if (hasAddress && hasLatLong) {
										locationTextField.helperText = record.location.latitude + ', ' + record.location.longitude;
									} else if (!hasAddress && hasLatLong) {
										var locationHelperParts = [];
										if (record.location.city) {
											locationHelperParts.push(record.location.city);
										}
										if (record.location.stateProv) {
											locationHelperParts.push(record.location.stateProv);
										}
										locationTextField.helperText = locationHelperParts.join(' ');
									} else {
										locationTextField.helperText = '';
									}
								}
							});
						} else {
							updateTractorCB();							
						}
					}
				}
			});			
			
		};
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.stopId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getTripService().deleteTripStops(multipleIds)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed: ' + multipleIds.ids.length, {									
									theme: 'success'
								});
								var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
								tripStopGrid.dispatchEvent(refreshEvent);
							})
							.catch(function(error){
								loadMask.remove();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
			
			
		};
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'TRIP',				
				uploadUrl: '/api/resource/trip-stops/import'
			});
		};		
		
		var actionTransferToGPS = function(records) {			
			var tractorId = ElementUtil.query(tripStopGrid.toolbarFilter, 'filterTractorId').value;
			
			var request = {
				originReferenceType: 'TRACTOR',
				originReferenceId: tractorId,
				tractorIdTransferTo: tractorId,  //For now transfer just the same...most likely the desired case
				dataIds: []				
			};
			records.forEach(function(record){
				request.dataIds.push(
					record.stopId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm GPS Creation',
				message: 'Are you sure you want to create GPS locations for the selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Creating GPS Records...');

							DataManagementService.getTripService().transferStopsToGPS(request)
							.then(function(results){
								loadMask.remove();
						
								if (results.success) {
									window.DL.MessageUtil.showToast('Success', 'Created/Updated: ' + request.dataIds.length + ' GPS records.', {									
										theme: 'success'
									});
									tripStopGrid.refreshGrid();
								}
							})
							.catch(function(error){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
		};	
		
		var actionShowMap = function(records) {
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map',
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();
						
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'dl-action-button',					
									'class': 'spacer-toolbar-item',
									style: 'width: 225px;',
									permissions: [],
									children:[
										ElementUtil.makeIcon('vaadin:cogs', ' View')
									],
									properties: {
										menu: [
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Satellite',
												listeners: {
													click: function(event) {
														map.showSatellite();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Terrain',
												listeners: {
													click: function(event) {
														map.showTerrain();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Transportation',
												listeners: {
													click: function(event) {
														map.showTransportation();
													}
												}
											}

										]
									}					
								}								
							]
						});						
						
						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								toolbar,
								map				
							]
						});	
						
						mapWin.addToContentElement(mapFlexLayout);
						
						setTimeout(function(){
							
							var highRes = [];
							records.forEach(function(record){
								if (record.location.longitude && record.location.latitude) {
									highRes.push(record);
								}
							});
															
							highRes.forEach(function(record){
								var longLats = [record.location.longitude, record.location.latitude];

								var date = TimeUtil.parseDate(record.arrivalDts);						
								var info = TimeUtil.formatDateStandard(date) + '<br>' 
										+ ' Trip No: ' + record.tripRefNo + '<br>'
										+ ' Stop No: ' + record.stopSeqNo + '<br>' 
										+ ' Stop Type: ' + record.stopTypeDescription + '<br>'								
										+ record.location.addressLine1 + ' ' + record.location.city + ', ' + record.location.stateProv + ' ' + record.location.country + '<br>'
										+ record.location.latitude + ', ' + record.location.longitude;

								map.addMarker(longLats, {
									popupHTML: info
								});
							});

							if (highRes.length === 1) {
								setTimeout(function() {
									map.zoomOnPoint([
										highRes[0].location.longitude,
										highRes[0].location.latitude
									]);
								}, 1000);
							}
							
						}, 200);						

					}
				}
			});		
		};
		
	}
		
	refreshGrid() {
		var tripStopGrid = this;		
		tripStopGrid.actionRefresh();
	}
	
	setFilterContainer(filterContainer) {
		var tripStopGrid = this;		
		tripStopGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-trip-stops-grid', TripStopGrid);

